import { getCurrentPentagonArea, tooltipLabelFormatter } from '../helpers';
import { format as unitFormat } from '../../../../../../units';
import { resolveColor } from '../../../../../../colors';

const PointToolTip = ({
  pointTooltip,
  setPointTooltip,
  timezone,
  data,
  series,
  plots,
  pentagonWidth,
  pentagonHeight,
}) => (
  <div
    // Positioning tooltip so it doesn't overflow screen
    ref={(element) => {
      if (!element) return;

      if (window.innerWidth - pointTooltip.position.x - element.getBoundingClientRect().width < 0) {
        setPointTooltip((prev) => ({
          ...prev,
          position: {
            ...prev.position,
            x: pointTooltip.position.x - element.getBoundingClientRect().width - 20,
          },
        }));
      }

      if (
        window.innerHeight - pointTooltip.position.y - element.getBoundingClientRect().height <
        0
      ) {
        setPointTooltip((prev) => ({
          ...prev,
          position: {
            ...prev.position,
            y: pointTooltip.position.y - element.getBoundingClientRect().height - 20,
          },
        }));
      }
    }}
    className="tooltip"
    style={{
      left: pointTooltip.position.x,
      top: pointTooltip.position.y,
    }}
  >
    <table>
      <thead>
        <tr>
          <th colSpan={7}> {tooltipLabelFormatter(pointTooltip.time, timezone)}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>Plot</th>
          <th>H2</th>
          <th>C2H2</th>
          <th>C2H4</th>
          <th>CH4</th>
          <th>C2H6</th>
          <th>Area</th>
        </tr>

        {plots.map((plot, index) => {
          const h2Serie = series.find((serie) => serie.id === plot.h2Id);
          const c2h6Serie = series.find((serie) => serie.id === plot.c2h6Id);
          const ch4Serie = series.find((serie) => serie.id === plot.ch4Id);
          const c2h4Serie = series.find((serie) => serie.id === plot.c2h4Id);
          const c2h2Serie = series.find((serie) => serie.id === plot.c2h2Id);

          if (!h2Serie || !ch4Serie || !c2h6Serie || !c2h4Serie || !c2h2Serie) {
            return null;
          }

          const timeData = data.find((d) => d.time === pointTooltip.time);
          if (!timeData) {
            return null;
          }

          const h2 = timeData[h2Serie.id];
          const ch4 = timeData[ch4Serie.id];
          const c2h6 = timeData[c2h6Serie.id];
          const c2h4 = timeData[c2h4Serie.id];
          const c2h2 = timeData[c2h2Serie.id];

          if (!h2 || !ch4 || !c2h6 || !c2h4 || !c2h2) {
            return null;
          }
          return (
            <tr
              style={{
                color: resolveColor(plot.color),
              }}
              key={index}
            >
              <td>{plot.label ?? 'No label'}</td>
              <td>
                {`${unitFormat(h2Serie.unit, h2, h2Serie.decimals, h2Serie.customUnit).value} ${
                  unitFormat(h2Serie.unit, h2, undefined, h2Serie.customUnit).unit
                }`}
              </td>
              <td>
                {`${unitFormat(c2h6Serie.unit, c2h6, c2h6Serie.decimals, c2h6Serie.customUnit).value} ${
                  unitFormat(c2h6Serie.unit, c2h6, undefined, c2h6Serie.customUnit).unit
                }`}
              </td>
              <td>
                {`${unitFormat(ch4Serie.unit, ch4, ch4Serie.decimals, ch4Serie.customUnit).value} ${
                  unitFormat(ch4Serie.unit, ch4, undefined, ch4Serie.customUnit).unit
                }`}
              </td>
              <td>
                {`${unitFormat(c2h4Serie.unit, c2h4, c2h4Serie.decimals, c2h4Serie.customUnit).value} ${
                  unitFormat(c2h4Serie.unit, c2h4, undefined, c2h4Serie.customUnit).unit
                }`}
              </td>
              <td>
                {`${unitFormat(c2h2Serie.unit, c2h2, c2h2Serie.decimals, c2h2Serie.customUnit).value} ${
                  unitFormat(c2h2Serie.unit, c2h2, undefined, c2h2Serie.customUnit).unit
                }`}
              </td>
              <td>
                {getCurrentPentagonArea({
                  h2,
                  c2h6,
                  ch4,
                  c2h4,
                  c2h2,
                  duvalType: plot.duvalType,
                  pentagonWidth,
                  pentagonHeight,
                })}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

export default PointToolTip;
